import React, {useContext, useState} from 'react';
import {SessionContext} from './SessionContext';
import {useHistory} from "react-router-dom";
import {Helmet} from "react-helmet";
import PrintersTab from "./PrintersTab";
import ConsentStep from "./ConsentStep";
import TermsContent from "./legal/TermsContent";
import PrivacyPolicyContent from "./legal/PrivacyPolicyContent";

/**
 * Ekran po zalogowaniu dla użytkownika, który nie zaakceptował jeszcze regulaminu
 * (flaga FLAG_RULES po stronie serwera). Dwa kroki: regulamin, potem polityka prywatności.
 * Zapis akceptacji następuje dopiero po drugim kroku.
 */
const Consents = () => {
  const history = useHistory();
  const context = useContext(SessionContext);
  const [step, setStep] = useState(0);

  const goTo = (s) => {
    setStep(s);
    window.scrollTo(0, 0);
  }

  const finish = () => {
    context.acceptRules(() => history.push(PrintersTab.url));
  }

  return <>
    <Helmet>
      <title>Regulamin i polityka prywatności</title>
    </Helmet>
    {step === 0
      ? <ConsentStep key="terms" step={1} total={2} title="Regulamin"
                     checkboxLabel="Akceptuję Regulamin korzystania z systemu Documaster Globalservice"
                     nextLabel="Dalej" onNext={() => goTo(1)} onLogout={() => context.logout()}>
          <TermsContent/>
        </ConsentStep>
      : <ConsentStep key="privacy" step={2} total={2} title="Polityka prywatności"
                     checkboxLabel="Zapoznałem/-am się z Polityką prywatności Documaster Globalservice"
                     nextLabel="Zakończ" onNext={finish} onBack={() => goTo(0)} onLogout={() => context.logout()}>
          <PrivacyPolicyContent/>
        </ConsentStep>
    }
  </>
}

Consents.url = '/consents';

export default Consents;
